<section class="contacts">
	<div class="messenger">
		<img src="images/telegram.svg" alt="telegram contact" />
		<div><a href="https://t.me/web2ls">@web2ls</a></div>
	</div>

	<div class="messenger">
		<img src="images/skype.svg" alt="skype contact" />
		<div><a href="skype:web2ls?chat">@web2ls</a></div>
	</div>

	<div class="messenger">
		<img src="images/email.svg" alt="email contact" />
		<div>android4hands@gmail.com</div>
	</div>
</section>

<style>
	.contacts {
		position: absolute;
		bottom: 20px;
		right: 20px;
		display: flex;
		flex-direction: column;
		justify-content: start;
		align-items: start;
	}

	.messenger {
		display: flex;
		align-items: center;
		margin-bottom: 10px;
		cursor: pointer;
		font-size: 16px;
	}

	.messenger img {
		width: 20px;
		height: 20px;
		margin-right: 10px;
		filter: grayscale(100%);
	}

	.messenger a {
		color: #fff;
		text-decoration: none;
	}

	@media (max-width: 1024px) {
		.contacts {
			bottom: 5px;
			right: 5px;
		}
	}

	@media (max-width: 768px) {
		.contacts {
			align-items: end;
			bottom: 5px;
			right: 5px;
		}

		.messenger {
			font-size: 12px;
		}

		.messenger img {
			width: 15px;
			height: 15px;
		}
	}
</style>
